import { Navigate, Outlet, useParams } from 'react-router-dom';
import useSchoolyear from 'queries/schoolyears/useSchoolyear';
import React from 'react';
import { routes } from 'containers/routes';
import SpinnerComponent from 'components/Spinner/ScreenSpinner';

export function SchoolyearDataProvider() {
  const { schoolyearId } = useParams<{
    schoolyearId: string;
  }>();
  const {
    data: schoolyear,
    error,
    isLoading,
    isFetching,
  } = useSchoolyear(schoolyearId as string, true, false);

  if (isLoading) {
    return <SpinnerComponent />;
  }

  if (error?.response?.status === 404 || error?.response?.status === 400) {
    return <Navigate to={routes.schoolyearsSettings} />;
  }
  return (
    <Outlet
      context={{
        schoolyear,
        isSchoolyearFetching: isFetching,
      }}
    />
  );
}
